export default "__VITE_ASSET__Bk87fqJH__"